export const EVENT_WINDOW = 6;
export const IS_CARD_SEEN_SESSION_KEY = "isCarCardSeen";
export const CAR_VIEWED_SESSION_KEY = "carCarsViewed";
